import Decimal from "decimal.js";

// 1 MILLION DOLLAR , multiplied by 100 to avoid writing cents as decimals
export const DROP_DECIMAL_THRESHOLD = new Decimal("1_000_000").mul(100);

export const COMMENT_CHAR_LIMIT = 1000;

// one hundred billion
export const MAX_NUMBER_CURRENCY_LIMIT = new Decimal("100_000_000_000");

export const DEFAULT_MAX_LINEITEM_DEPTH_LEVEL = 6;

export const EPSILON = 2.3283064365386963e-10 || new Decimal(Number.EPSILON);

export const MAX_CLAIM_NUMBER_THRESHOLD = new Decimal("9999999");
